import { render, staticRenderFns } from "./empty-form.vue?vue&type=template&id=610d8ab9&"
import script from "./empty-form.vue?vue&type=script&lang=js&"
export * from "./empty-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports